import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const hasText = input => input.text !== ''
const questionHasText = question => hasText(question) && question.answers.every(hasText)

const pollValidationSelector = createSelector(
	[state => state.poll],
	pollState => {
		const questions = pollState.questions
		const hasExceedChars = questions.some(question => question.hasExceedChars)
		const valid = !hasExceedChars && questions.every(question => questionHasText(question))

		return {
			valid,
			message: valid ? null : (hasExceedChars ? localize('global_review_information_error') : localize('quiz_complete_fields')),
		}

	}
)

export default pollValidationSelector
